export default __webpack_public_path__ + "static/media/028-traffic lights.195911bc.png";